import GlobalLoader from "./components/shared/global-load";
import AppProvider from "./providers";
import AppRouter from "./routes";

function App() {
  return (
    <AppProvider>
      <GlobalLoader>
        <AppRouter />
      </GlobalLoader>
    </AppProvider>
  );
}

export default App;
